import { useTranslations } from 'next-intl';

import { Datetime } from '@flipster/react/design-utils/datetime';
import Formatted from '@flipster/react/design-utils/formatted';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import { UsdtPrecision } from '@flipster/utils/constants/currency';

interface Props {
  triggerTime: string;
  estPnlPercent?: string;
}

const TriggerTimeInfos = ({ triggerTime, estPnlPercent }: Props) => {
  const transTrade = useTranslations('Trade.r250401');
  const transPosition = useTranslations('Position.r250401');
  return (
    <dl
      className={vstack({
        alignItems: 'flex-start',
        gap: 4,
        p: 12,
        mb: 8,
        bgColor: 'background.default.level-3',
        rounded: 8,

        '& > div': {
          w: '100%',
          display: 'flex',
          gap: 4,
          textStyle: 'Text/L/Regular',
        },
        '& dt': { flex: 1 },
        '& dd': { textAlign: 'right' },
      })}
    >
      <div>
        <dt>{transTrade('Trigger_time')}</dt>
        <dd>
          <Datetime value={triggerTime} format='MMM dd, yyyy, HH:mm:ss' /> UTC
          <Datetime value={triggerTime} format='xxx' />
          <p>{transTrade('At_market_price')}</p>
        </dd>
      </div>
      <div>
        <dt>{transPosition('Est_pnl_colon')}</dt>
        <dd>
          {!estPnlPercent ? (
            <p className={css({ color: 'content.default.level-2' })}>-</p>
          ) : (
            <Formatted.Percent
              css={{ textStyle: 'Legacy/Number2' }}
              value={estPnlPercent}
              precision={UsdtPrecision}
              withPlus
              toFixed
              withColor
            />
          )}
        </dd>
      </div>
    </dl>
  );
};

export default TriggerTimeInfos;
